<template>
  <div class="InventoryShrimpInfo pt7" v-title data-title="库虾内容">
    <div class="pb7" v-for="(info, index) in infoList" :key="index">
      <van-field
        v-model="info.title"
        clearable
        label="库虾标题"
        placeholder="请输入库虾标题"
        type="textarea"
        rows="1"
        autosize
      />
      <van-field
        v-model="info.content"
        clearable
        label="库虾内容"
        placeholder="请输入库虾内容"
        type="textarea"
        rows="2"
        autosize
      />
    </div>
    <div class="pb5" v-if="!infoList||infoList.length<1">
      今日还未发布库虾信息，<span class="fc-primary" @click="copy">复制昨日信息</span>
    </div>
    <van-button @click="add" plain class="btn" type="info"><van-icon name="plus"/> 增加一栏</van-button>
    <div class="save pt10">
      <van-button @click="saveInventoryShrimpInfo" class="btn" type="info">发布</van-button>
      <div class="pt5"><van-button @click="back" size="small" type="info" plain>返回</van-button></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { sendRequest, getInventoryShrimpInfo, saveInventoryShrimpInfo } from '../network/NetworkAccessor';

export default Vue.extend({
  name: 'InventoryShrimpInfo',
  components: {},
  data() {
    return {
      infoList: [{ title: '', content: '' }],
    };
  },
  methods: {
    add() {
      this.infoList.push({ title: '', content: '' });
    },
    getInventoryShrimpInfo(pd) {
      const date = pd || new Date();
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const queryDate = `${date.getFullYear()}${monthStr}${dStr}`;
      sendRequest(getInventoryShrimpInfo, { queryDate }).then((res) => {
        // console.log(res);
        this.infoList = res || [];
        if (!this.infoList || this.infoList.length < 1) {
          this.add();
        }
      }).catch((e) => {
        this.$dialog.alert({
          message: (e || {}).message,
        });
      });
    },
    copy() {
      let yestoday = new Date();
      yestoday = new Date(yestoday.setTime(yestoday.getTime() - 1000 * 60 * 60 * 24));
      this.getInventoryShrimpInfo(yestoday);
    },
    saveInventoryShrimpInfo() {
      const infoList = this.infoList.filter(il => il.title || il.content);
      sendRequest(saveInventoryShrimpInfo, infoList).then((res) => {
        this.$dialog.alert({
          message: '发布库虾内容成功',
        });
        // this.$router.back();
        this.back();
      }).catch((e) => {
        this.$dialog.alert({
          message: (e || {}).message || '发布库虾内容失败',
        });
      });
    },
    back() {
      this.$router.push('/home');
    },
  },
  created() {
    this.getInventoryShrimpInfo();
  },
});
</script>
<style scoped>
  .InventoryShrimpInfo {
    min-height: 100vh;
  }
  .title {
    padding: 20px 0;
    font-size: 20px;
  }
  .add-box {
    padding: 30px 15px;
  }
  .add {
    padding: 10px 15px;
  }
  .van-cell {
    text-align: left;
  }
  .btn {
    width: 80%;
  }
  .btn-reset {
    width: 25%;
    margin: 0 10px;
  }
</style>
